<section class="carousel-wrapper">
  <swiper-container
    #swiperRef
    class="carousel-swiper"
    (slidechange)="onSlideChange($event)"
  >
    <swiper-slide *ngFor="let slide of slides">
      <div class="carousel-container" data-automation-id="Carousel-Container">
        <div class="carousel-left" data-automation-id="Carousel-Left">
          <img
            class="rotated-img"
            [src]="slide.image"
            [alt]="slide.title"
            data-automation-id="Carousel-Image"
          />
        </div>
        <div class="carousel-right" data-automation-id="Carousel-Right">
          <div class="heading" data-automation-id="Carousel-Heading">
            {{ slide.title }}
          </div>
          <div class="subtext" data-automation-id="Carousel-Subtext">
            {{ slide.description }}
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>

  <div class="custom-pagination" *ngIf="settings.pagination">
    <span
      *ngFor="let _ of slides; let i = index"
      [class.active]="i === activeIndex"
      [class.disabled]="!settings.loop && i === activeIndex"
      (click)="goToSlide(i)"
    ></span>
  </div>
</section>
